import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksRightSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 3h2v18h-2V3zm-2 3H3v5h13V6zm0 7H6v5h10v-5z" />
  </svg>
);
export default IconAlignBlocksRightSizeM;
